export interface IRemoveCircleProps {
  onClick?: () => void;
}
const RemoveCircle = ({ onClick }: IRemoveCircleProps) => {
  return (
    <svg
      onClick={onClick}
      className="min-w-24px position-absolute top-50 cursor-pointer"
      style={{ marginTop: "-12px", right: "-30px" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92898 19.0711C1.02373 15.1658 1.02373 8.83418 4.92898 4.92893C8.83422 1.02369 15.1659 1.02369 19.0711 4.92893C22.9764 8.83418 22.9764 15.1658 19.0711 19.0711C15.1659 22.9763 8.83422 22.9763 4.92898 19.0711ZM6.21463 6.21458C3.01943 9.40978 3.01943 14.5902 6.21463 17.7854C9.40983 20.9806 14.5903 20.9806 17.7855 17.7854C20.9807 14.5902 20.9807 9.40978 17.7855 6.21458C14.5903 3.01938 9.40983 3.01938 6.21463 6.21458ZM8.78592 8.78588C9.14095 8.43086 9.71655 8.43086 10.0716 8.78588L12 10.7144L13.9285 8.78588C14.2835 8.43086 14.8591 8.43086 15.2142 8.78588C15.5692 9.1409 15.5692 9.7165 15.2142 10.0715L13.2857 12L15.2142 13.9285C15.5692 14.2835 15.5692 14.8591 15.2142 15.2141C14.8591 15.5691 14.2835 15.5691 13.9285 15.2141L12 13.2856L10.0716 15.2141C9.71655 15.5691 9.14095 15.5691 8.78592 15.2141C8.4309 14.8591 8.4309 14.2835 8.78592 13.9285L10.7144 12L8.78592 10.0715C8.4309 9.71651 8.4309 9.1409 8.78592 8.78588Z"
        fill="black"
      />
    </svg>
  );
};

export default RemoveCircle;
